module.exports = __webpack_public_path__ + "img/32.88f1a44f.jpg";